import { Validator } from '@vista-digital/validator';
import { carouselSettingsValidator } from './settings';
export const carouselConfigValidator = Validator.object({
    scrollToSlide: Validator.optional(Validator.number()),
    scrollToPage: Validator.optional(Validator.number()),
    showDots: Validator.optional(Validator.boolean()),
    refreshOnUpdate: Validator.optional(Validator.boolean()),
    settings: Validator.optional(carouselSettingsValidator),
    touchSettings: Validator.optional(carouselSettingsValidator)
});
